export const convertNotificationsCustom = text => {
  return {
    notification_body: text,
    notification_title: '',
    current_link: '',
    new_link: '',
  };
};
